import { Divider } from '@shipengine/giger';
import { TrackingReferenceNumber } from './TrackingReferenceNumber.js';
import { TrackingParcelCount } from './TrackingParcelCount.js';
import { useTranslation } from '@packlink/translation-provider';
import { getTrackingDetailsStyles, getTrackingDetailsHeaderStyles, getTrackingDetailsParcelCountStyles, getTrackingDetailsSummaryStyles, getTrackingDetailsParcelListStyles, getTrackingDetailsParcelStyles } from './TrackingDetailsStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';
import { MetricsProvider } from '../MetricsProvider/MetricsProvider.js';
import { TrackingSummary } from '../TrackingSummary/TrackingSummary.js';
import { ParcelTracking } from '../ParcelTracking/ParcelTracking.js';

const TrackingDetailsParcelMismatchError = new Error('Tracking parcels and shipment parcels differ');
function TrackingDetails(_ref) {
  let {
    tracking,
    shipment,
    metrics,
    ...otherProps
  } = _ref;
  shipment && validateProps(tracking, shipment);
  const parcels = useParcelData(tracking.parcels, shipment);
  const isSingleParcel = parcels.length === 1;
  return jsx(MetricsProvider, {
    metrics: metrics,
    children: jsxs("article", {
      css: getTrackingDetailsStyles,
      ...otherProps,
      children: [jsxs("header", {
        css: getTrackingDetailsHeaderStyles,
        children: [jsx(TrackingReferenceNumber, {
          "data-id": "tracking-reference-number",
          shipmentReference: tracking.shipmentReference
        }), jsx(TrackingParcelCount, {
          css: getTrackingDetailsParcelCountStyles,
          "data-id": "tracking-parcel-count",
          parcels: parcels
        })]
      }), jsx(Divider, {}), jsx(TrackingSummary, {
        "data-id": "tracking-summary",
        css: getTrackingDetailsSummaryStyles,
        tracking: tracking,
        shipment: shipment
      }), jsx(Divider, {}), jsx("section", {
        css: getTrackingDetailsParcelListStyles,
        "data-id": "tracking-parcels",
        children: parcels.map((parcel, index) => jsx(ParcelTracking, {
          css: getTrackingDetailsParcelStyles,
          parcel: parcel,
          alwaysShowTimeline: isSingleParcel
        }, `${parcel.carrierTrackingNumber}_parcel_${index}`))
      })]
    })
  });
}
function validateProps(tracking, shipment) {
  var _shipment$parcels;
  // For consistency we should check if all relevant data is well formed
  // tracking and shipment should have the same number of packages
  if (tracking.parcels.length !== (shipment === null || shipment === void 0 ? void 0 : (_shipment$parcels = shipment.parcels) === null || _shipment$parcels === void 0 ? void 0 : _shipment$parcels.length)) {
    throw TrackingDetailsParcelMismatchError;
  }
}
function useParcelData(trackingParcels, shipment) {
  var _shipment$parcels2;
  const {
    t
  } = useTranslation();
  const parcels = (_shipment$parcels2 = shipment === null || shipment === void 0 ? void 0 : shipment.parcels) !== null && _shipment$parcels2 !== void 0 ? _shipment$parcels2 : [];
  const service = shipment === null || shipment === void 0 ? void 0 : shipment.service;
  const parcelNameBlacklist = ['custom-parcel-id'];
  return trackingParcels.map((trackingData, index) => {
    var _parcels$index;
    const {
      name,
      width,
      weight,
      length,
      height
    } = (_parcels$index = parcels[index]) !== null && _parcels$index !== void 0 ? _parcels$index : {};
    const cleanName = parcelNameBlacklist.includes(String(name)) ? undefined : name;
    return {
      ...trackingData,
      name: cleanName || t('tracking-details.parcels.parcel-name', {
        index: index + 1
      }),
      weight,
      length,
      height,
      width,
      trackingUrl: service === null || service === void 0 ? void 0 : service.trackingUrl
    };
  });
}

export { TrackingDetails, TrackingDetailsParcelMismatchError };
//# sourceMappingURL=TrackingDetails.js.map
